module.exports = __webpack_public_path__ + "static/media/monterrey.c83ed683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/monterrey.png
// module id = 623
// module chunks = 0